// Remove injected blur canvas
(function() {
  document.querySelectorAll('head style').forEach(function(s) { if (s.textContent.indexOf('--slide-bg') > -1) s.remove(); });
  var fix = document.createElement('style');
  fix.textContent = '@media screen and (max-width:992px){.image-main .slide::after{display:none!important}}';
  document.head.appendChild(fix);
})();

// Match slick-dots width to visible image width (object-fit: contain)
function syncDotsWidth() {
  if (window.innerWidth > 992) return;
  var img = document.querySelector('.image-main .slick-current img') || document.querySelector('.image-main .slide img');
  var dots = document.querySelector('.feature-image-slider-container .slick-dots');
  if (!img || !dots) return;

  var containerW = img.offsetWidth;
  var containerH = img.offsetHeight;
  var naturalW = img.naturalWidth;
  var naturalH = img.naturalHeight;
  if (!naturalW || !naturalH) return;

  var imgRatio = naturalW / naturalH;
  var containerRatio = containerW / containerH;
  var visibleW = containerRatio > imgRatio ? containerH * imgRatio : containerW;

  dots.style.width = Math.round(visibleW) + 'px';
  dots.style.margin = '-27px auto -20px';
}

document.addEventListener('DOMContentLoaded', function() {
  var img = document.querySelector('.image-main .slide img');
  if (img) {
    if (img.complete) syncDotsWidth();
    else img.addEventListener('load', syncDotsWidth);
  }
  window.addEventListener('resize', syncDotsWidth);
  var observer = new MutationObserver(syncDotsWidth);
  var imageMain = document.querySelector('.image-main');
  if (imageMain) observer.observe(imageMain, { attributes: true, subtree: true, attributeFilter: ['class'] });
});
var slickOptionsMain = {
  centerMode: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  vertical: true,
  verticalSwiping: true,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: false,
        verticalSwiping: false,
        dots: true,
      },
    },
  ],
};
$(function () {
  const current_sku = $('input[type=hidden]#hidden-product-sku').val();
  const product_type = $('input[type=hidden]#hidden-product-type').val();
  const product_is_ready_to_ship = $(
    'input[type=hidden]#hidden-ready-to-ship-enabled'
  ).val();
  const is_rtw = $('input[type=hidden]#hidden-is-rtw').val();
  const have_active_swatch = $('.active-swatch');

  // Prepare helpers to rebuild the mobile slider from the original slides
  // Defined early to capture clean HTML before any Slick init
  function initColorRebuilds() {
    const $imgMain = $('.image-main');
    if (!$imgMain.length) return;
    if (!$imgMain.data('original-slides-html')) {
      $imgMain.data('original-slides-html', $imgMain.html());
    }
  }
  initColorRebuilds();

  function showColorSlidesMobile(color) {
    const $imgMain = $('.image-main');
    if (!$imgMain.length) return;
    const originalHtml = $imgMain.data('original-slides-html');
    if (!originalHtml) return;

    // Ensure slick is removed before rebuilding
    if ($imgMain.hasClass('slick-initialized')) {
      try {
        $imgMain.slick('unslick');
      } catch (e) {
        // ignore
      }
    }

    const $temp = $('<div>').html(originalHtml);
    const target = (color || '').toString().toLowerCase();
    const $filtered = $temp.find('.slide').filter(function () {
      const slideColor = ($(this).data('color') || '').toString().toLowerCase();
      return slideColor === target;
    });

    const $finalSlides = $filtered.length ? $filtered : $temp.find('.slide');
    // Remove server-side display:none from slides that were hidden for non-default colors
    $finalSlides.removeAttr('style');
    $imgMain.empty().append($finalSlides);

    // Cleanup any leftover slick artifacts
    $imgMain.find('.slick-cloned').remove();

    // Init slick for mobile viewport
    if ($(window).width() < 992) {
      setTimeout(function () {
        try {
          if (!$imgMain.hasClass('slick-initialized')) {
             $imgMain.slick(slickOptionsMain);
          }
        } catch (e) {
          // ignore
        }
        // Mark hidden Slick slides as inert for a11y
        $imgMain.find('.slick-slide[aria-hidden="true"]').attr('inert', '');
        setTimeout(syncDotsWidth, 100);
      }, 50);
    }
  }

  // Track whether color came from an explicit ?color= URL param
  var _colorFromUrlParam = false;

  function getColorFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const colorParam = urlParams.get('color');
    if (colorParam) {
      _colorFromUrlParam = true;
      return colorParam;
    }

    _colorFromUrlParam = false;

    // Try to extract color from product slug (e.g. "ever-hunter" → "hunter")
    const currentPath = window.location.pathname;
    const pathParts = currentPath.split('/');
    const productSlug = pathParts[pathParts.length - 1];

    if (productSlug && productSlug.includes('-')) {
      const parts = productSlug.split('-');
      if (parts.length >= 2) {
        const potentialColor = parts.slice(1).join('-');
        // Validate against actual swatches to avoid false positives
        // e.g. "slouch-dress" from "/products/jacquard-slouch-dress"
        var isValidColor = false;
        var potentialLower = potentialColor.toLowerCase();
        var potentialNormalized = potentialLower.replace(/-/g, ' ');
        $('.swatch-element').each(function () {
          var swatchVal = ($(this).attr('data-colorname-value') || '').toLowerCase();
          var swatchNormalized = swatchVal.replace(/-/g, ' ');
          if (swatchVal === potentialLower || swatchNormalized === potentialNormalized || swatchVal.includes(potentialLower) || potentialLower.includes(swatchVal) || swatchNormalized.includes(potentialNormalized) || potentialNormalized.includes(swatchNormalized)) {
            isValidColor = true;
            return false;
          }
        });
        if (isValidColor) {
          _colorFromUrlParam = true;
          return potentialColor;
        }
      }
    }

    // Fall back to last clicked color from collection page
    const lastClickedColor = localStorage.getItem('lastClickedColor');
    if (lastClickedColor) {
      return lastClickedColor;
    }

    return null;
  }

  function checkColorMatching(urlColor) {
    if (!urlColor) return null;

    const baseLower = urlColor.toLowerCase();
    const baseNormalized = baseLower.replace(/-/g, ' ');
    let matchedSwatch = null;

    $('.swatch-element').each(function () {
      const swatchColor = $(this).attr('data-colorname-value').toLowerCase();
      const swatchNormalized = swatchColor.replace(/-/g, ' ');
      if (swatchColor === baseLower || swatchNormalized === baseNormalized) {
        matchedSwatch = $(this);
        return false;
      }
    });
    if (!matchedSwatch) {
      const colorJsonUrl =
        document.getElementById('color-json-url')?.value ||
        '/assets/amsale_colors_full.json';

      $.ajax({
        url: colorJsonUrl,
        dataType: 'json',
        async: false,
        success: function (colorDictionary) {
          const baseEntry = colorDictionary[baseLower];

          if (baseEntry && Array.isArray(baseEntry.base)) {
            $('.swatch-element').each(function () {
              const swatchValue = $(this)
                .attr('data-colorname-value')
                .toLowerCase();

              if (
                baseEntry.base.some((baseColor) =>
                  swatchValue.includes(baseColor.toLowerCase())
                )
              ) {
                matchedSwatch = $(this);
                return false;
              }
            });
          }

          if (!matchedSwatch) {
            for (const [colorKey, colorEntry] of Object.entries(
              colorDictionary
            )) {
              if (
                Array.isArray(colorEntry.base) &&
                colorEntry.base.some((b) => b.toLowerCase() === baseLower)
              ) {
                $('.swatch-element').each(function () {
                  const swatchValue = $(this)
                    .attr('data-colorname-value')
                    .toLowerCase();
                  if (
                    swatchValue === colorKey.toLowerCase() ||
                    swatchValue.includes(colorKey.toLowerCase())
                  ) {
                    matchedSwatch = $(this);
                    return false;
                  }
                });

                if (matchedSwatch) break;
              }
            }
          }
        },
      });
    }

    return matchedSwatch;
  }

  function getMatchingSwatches(baseColor) {
    if (!baseColor) return [];

    const baseLower = baseColor.toLowerCase();
    const exact = [];
    const soft = [];
    const availableSwatches = [];
    $('.swatch-element').each(function () {
      availableSwatches.push({
        element: $(this),
        value: $(this).attr('data-colorname-value').toLowerCase(),
        name: $(this).attr('data-value').toLowerCase(),
      });
    });

    let colorJsonUrl = '/assets/amsale_colors_full.json';
    const colorJsonElement = document.getElementById('color-json-url');
    colorJsonUrl = colorJsonElement.value;
    $.ajax({
      url: colorJsonUrl,
      dataType: 'json',
      async: false,
      success: function (colorDictionary) {
        const baseEntry = colorDictionary[baseLower];

        if (baseEntry && Array.isArray(baseEntry.base)) {
          for (const swatch of availableSwatches) {
            if (
              baseEntry.base.some(
                (baseColor) =>
                  swatch.value.includes(baseColor.toLowerCase()) ||
                  swatch.name.includes(baseColor.toLowerCase())
              )
            ) {
              soft.push(swatch.element);
            }
          }
        }

        if (soft.length === 0) {
          for (const [colorKey, colorEntry] of Object.entries(
            colorDictionary
          )) {
            if (Array.isArray(colorEntry.base)) {
              if (
                colorEntry.base.some(
                  (b) =>
                    b.toLowerCase() === baseLower ||
                    b.toLowerCase().includes(baseLower) ||
                    baseLower.includes(b.toLowerCase())
                )
              ) {
                for (const swatch of availableSwatches) {
                  if (
                    swatch.value === colorKey ||
                    swatch.name === colorKey ||
                    swatch.value.includes(colorKey) ||
                    swatch.name.includes(colorKey)
                  ) {
                    soft.push(swatch.element);
                  }
                }
              }
            }
          }
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.error(
          'Erreur lors du chargement du dictionnaire de couleurs:',
          textStatus,
          errorThrown
        );
      },
    });

    applyMatchingColor([...exact, ...soft]);

    return [...exact, ...soft];
  }

  function applyMatchingColor(matches) {
    if (matches && matches.length > 0) {
      if ($firstSwatch.hasClass('active-swatch')) {
        $firstSwatch.removeClass('active-swatch');
      }
      matches[0]
        .addClass('active-swatch')
        .find('input')
        .prop('checked', true)
        .change();
      const colorTitle = matches[0].attr('data-colorname-value');
      document.querySelector('#selectedColor').textContent = colorTitle;
    } else {
      $('.swatch-element')
        .first()
        .addClass('active-swatch')
        .find('input')
        .prop('checked', true)
        .change();
    }
  }

  let selected_options = {
    sku: '',
    dress_size: '',
    dress_length: '',
    color: '',
  };
  const urlColor = getColorFromUrl();
  if (urlColor && !have_active_swatch.length) {
    selected_options.color = urlColor;
  }
  // Helper: extract color from "Shown in X" in product description
  function getShownInColor() {
    const descriptionEl = document.querySelector('.product-single__description');
    if (!descriptionEl) return null;

    const text = descriptionEl.textContent || '';
    const match = text.match(/shown\s+in\s+([a-zA-Z\s\-]+?)(?:\.|,|$)/i);
    if (match && match[1]) {
      return match[1].trim().toLowerCase();
    }
    return null;
  }

  // Helper: find a swatch element by color name (fuzzy)
  function findSwatchByColor(colorName) {
    if (!colorName) return null;

    const colorLower = colorName.toLowerCase();
    let $match = null;

    $('.swatch-element').each(function() {
      const swatchColor = ($(this).attr('data-colorname-value') || '').toLowerCase();
      if (swatchColor === colorLower || swatchColor.includes(colorLower) || colorLower.includes(swatchColor)) {
        $match = $(this);
        return false;
      }
    });

    return $match;
  }

  // Helper: apply best-matching color swatch on load
  // Priority: 1) "Shown in X" from description, 2) first image's color, 3) first swatch
  function applyShownInColorOrFirst() {
    let $swatchToSelect = $firstSwatch;

    // 1) Try "Shown in X" from product description
    const shownInColor = getShownInColor();
    if (shownInColor) {
      const $shownInMatch = findSwatchByColor(shownInColor);
      if ($shownInMatch) {
        $swatchToSelect = $shownInMatch;
      }
    }

    // 2) If still on first swatch, try matching the first image's color
    if ($swatchToSelect === $firstSwatch) {
      const $firstSlide = $('.image-main .slide[data-color]').first();
      if ($firstSlide.length) {
        const firstImageColor = ($firstSlide.attr('data-color') || '').toLowerCase();
        if (firstImageColor) {
          const $imgMatch = findSwatchByColor(firstImageColor);
          if ($imgMatch) {
            $swatchToSelect = $imgMatch;
          }
        }
      }
    }

    $('.swatch-element').removeClass('active-swatch');
    $swatchToSelect.addClass('active-swatch');
    const colorSwatch = $swatchToSelect.attr('data-colorname-value');
    if (colorSwatch && document.querySelector('#selectedColor')) {
      document.querySelector('#selectedColor').textContent = colorSwatch;
    }
  }

  $(document).ready(function () {
    const urlColor = getColorFromUrl();
    const multipleColors = $('.swatch-element').length > 1;
    // Only override with an explicit ?color= URL param.
    // localStorage / slug colors are already handled by the sync init block above;
    // re-applying them here causes a visible flicker (swatch resets after render).
    var _hasExplicitColorParam = new URLSearchParams(window.location.search).has('color');
    if (urlColor && multipleColors && _hasExplicitColorParam) {
      var matchedSwatch = checkColorMatching(urlColor);

      if (matchedSwatch) {
        var redirectLink = matchedSwatch.attr('data-rts-redirect-link');
        if (redirectLink && window.location.pathname !== redirectLink) {
          var resetOptions = {
            sku: '',
            dress_size: '',
            dress_length: '',
            color: matchedSwatch.attr('data-colorname-value'),
          };
          sessionStorage.setItem(
            'selected_options',
            JSON.stringify(resetOptions)
          );
        } else {
          // Skip visual re-application if swatch is already correctly set
          var alreadyCorrect = matchedSwatch.hasClass('active-swatch');

          if (!alreadyCorrect) {
            $('.swatch-element').removeClass('active-swatch');
            matchedSwatch
              .addClass('active-swatch')
              .find('input')
              .prop('checked', true)
              .change();

            if (document.querySelector('#selectedColor')) {
              document.querySelector('#selectedColor').textContent =
                matchedSwatch.attr('data-colorname-value');
            }
          }

          // Always sync Shopify select (needed for add-to-cart)
          setSwatchSelectValue(matchedSwatch.attr('data-colorname-value'));

          if (is_rtw == 'true') {
            fetchProductAndInventoryData(
              matchedSwatch.attr('data-colorname-value')
            );
          }

          // Reinitialize scrollbar for the new color on desktop
          if ($(window).width() > 992) {
            setTimeout(function () {
              var $imgMain = $('.image-main');
              var cleanup = $imgMain.data('scrollbar-cleanup');
              if (cleanup) cleanup();
              initNativeScrollBar();
            }, 150);
          }
        }
      } else {
        // URL color didn't match any swatch — fall back to "Shown in" color
        applyShownInColorOrFirst();
      }
    }
    // Swatch already set by applyShownInColorOrFirst() in the init block above
    (function () {
      const isRTS =
        $('input[type=hidden]#hidden-ready-to-ship-enabled').val() === 'true';
      if (!isRTS) return;

      function normalizePath(u) {
        try {
          const url = new URL(u, window.location.origin);
          return url.pathname.replace(/\/+$/, '');
        } catch (e) {
          return (u || '').replace(/\/+$/, '');
        }
      }

      function tryRedirectTo(link) {
        if (!link) return;
        const currentPath = normalizePath(window.location.pathname);
        const targetPath = normalizePath(link);

        const loopGuardKey = 'rts_redirected_once';
        if (
          currentPath !== targetPath &&
          !sessionStorage.getItem(loopGuardKey)
        ) {
          sessionStorage.setItem(loopGuardKey, '1');
          window.location.assign(link);
        } else {
          if (currentPath === targetPath)
            sessionStorage.removeItem(loopGuardKey);
        }
      }

      const $active = $('.swatch-element.active-swatch').first();
      if ($active.length) {
        tryRedirectTo($active.attr('data-rts-redirect-link'));
        return;
      }

      const $first = $('.swatch-element').first();
      if ($first.length) {
        tryRedirectTo($first.attr('data-rts-redirect-link'));
      }
    })();
  });
  window.scrollTo(0, 0);
  $(window).on('load', function () {
    window.scrollTo(0, 0);
  });

  if (product_is_ready_to_ship == 'true' && product_type == 'dress') {
    $('.product-select--dress-length select').prop('disabled', true);
  }

  const singleOptionSelector = document.querySelector(
    'select[aria-label="Dress Length"]'
  );
  const targetElement = document.querySelector(
    '.form-control.product-form__selects.product-select--dress-length.product-select--RTS'
  );

  if (singleOptionSelector && singleOptionSelector.options.length <= 1) {
    targetElement.style.display = 'none';
  }
  let $firstSwatch = $('.swatch-element').first();

  // FIRST: Override server-default swatch with "Shown in" color when present
  // (only explicit ?color= URL param takes priority over "Shown in")
  if (!_colorFromUrlParam) {
    var shownInColor = getShownInColor();
    if (shownInColor) {
      var $shownInMatch = findSwatchByColor(shownInColor);
      if ($shownInMatch) {
        var $currentActive = $('.swatch-element.active-swatch');
        var currentColor = $currentActive.length ? ($currentActive.attr('data-colorname-value') || '').toLowerCase() : '';
        var shownSwatchColor = ($shownInMatch.attr('data-colorname-value') || '').toLowerCase();
        if (currentColor !== shownSwatchColor) {
          applyShownInColorOrFirst();
        }
      }
    }
  }

  // THEN: Apply localStorage color (from collection page filter) synchronously
  // so it runs BEFORE handleResponsiveScroll() — no visible flicker.
  // Only if "Shown in" didn't already set a match above.
  if (!_colorFromUrlParam) {
    var _lastClickedColor = null;
    try { _lastClickedColor = localStorage.getItem('lastClickedColor'); } catch(e) {}
    if (_lastClickedColor) {
      var _shownInWasApplied = getShownInColor() && findSwatchByColor(getShownInColor());
      if (!_shownInWasApplied) {
        var _lcMatch = checkColorMatching(_lastClickedColor);
        if (_lcMatch) {
          $('.swatch-element').removeClass('active-swatch');
          _lcMatch.addClass('active-swatch')
            .find('input').prop('checked', true).change();
          if (document.querySelector('#selectedColor')) {
            document.querySelector('#selectedColor').textContent = _lcMatch.attr('data-colorname-value');
          }
          setSwatchSelectValue(_lcMatch.attr('data-colorname-value'));
        }
      }
    }
  }

  // Normal init for when no swatch is active (and nothing above set one)
  // Skip default color init if a URL color will be applied shortly
  var _pendingUrlColor = _colorFromUrlParam && getColorFromUrl();
  if (!$('.swatch-element.active-swatch').length) {
    if (_pendingUrlColor) {
      // URL color is pending — apply it now to avoid flicker
      var _urlMatchedSwatch = checkColorMatching(_pendingUrlColor);
      if (_urlMatchedSwatch) {
        $('.swatch-element').removeClass('active-swatch');
        _urlMatchedSwatch.addClass('active-swatch');
        if (document.querySelector('#selectedColor')) {
          document.querySelector('#selectedColor').textContent = _urlMatchedSwatch.attr('data-colorname-value');
        }
      } else {
        applyShownInColorOrFirst();
      }
    } else if (selected_options.color != '') {
      getMatchingSwatches(selected_options.color);
    } else {
      applyShownInColorOrFirst();

      // Handle RTS redirect for the selected swatch
      let $activeSwatch = $('.swatch-element.active-swatch');
      if ($activeSwatch.length) {
        let redirectLink = $activeSwatch.attr('data-rts-redirect-link');
        if (redirectLink && window.location.href !== redirectLink) {
          if (!sessionStorage.getItem('redirected')) {
            sessionStorage.setItem('redirected', 'true');
            window.location = redirectLink;
          } else {
            sessionStorage.removeItem('redirected');
            window.location.reload();
          }
        }
      }
    }
  } else if (!_pendingUrlColor) {
    // A swatch is already active (server default), but the customer may have had a
    // different color selected earlier in this session on this same product — restore
    // it instead of silently reverting to the server's default swatch on reload.
    // (selected_options.color isn't populated from sessionStorage until further below,
    // so read the session value directly here rather than relying on that variable.)
    // Use checkColorMatching (exact match first) rather than getMatchingSwatches,
    // which only does fuzzy "same color family" matching and can land on an
    // unrelated swatch (e.g. Amethyst -> any other purple swatch).
    var _priorSessionRaw = sessionStorage.getItem('selected_options');
    if (_priorSessionRaw) {
      var _priorSession = JSON.parse(_priorSessionRaw);
      if (_priorSession.sku === current_sku && _priorSession.color) {
        var _activeSwatchColor = (
          $('.swatch-element.active-swatch').attr('data-colorname-value') || ''
        ).toLowerCase();
        if (_activeSwatchColor !== _priorSession.color.toLowerCase()) {
          var _priorMatch = checkColorMatching(_priorSession.color);
          if (_priorMatch) {
            $('.swatch-element').removeClass('active-swatch');
            _priorMatch.addClass('active-swatch').find('input').prop('checked', true).change();
            if (document.querySelector('#selectedColor')) {
              document.querySelector('#selectedColor').textContent = _priorMatch.attr('data-colorname-value');
            }
            setSwatchSelectValue(_priorMatch.attr('data-colorname-value'));
          }
        }
      }
    }
  }
  // Clear stale localStorage color after init consumed it,
  // so it won't override on page refresh or future navigation.
  try { localStorage.removeItem('lastClickedColor'); } catch(e) {}

  const session_exists = sessionStorage.getItem('selected_options');
  if (session_exists && current_sku == JSON.parse(session_exists).sku) {
    selected_options.sku = JSON.parse(session_exists).sku;
    selected_options.dress_size = JSON.parse(session_exists).dress_size;
    selected_options.dress_length = JSON.parse(session_exists).dress_length;
    selected_options.color = JSON.parse(session_exists).color;

    if (selected_options.dress_size != '') {
      const size_select =
        $('.infinite-option-size-select select').length > 0
          ? $('.infinite-option-size-select select')
          : $('.product-select--size select');

      if (product_is_ready_to_ship == 'true' && product_type == 'dress') {
        // DO NOTHING
      } else {
        size_select.val(selected_options.dress_size);
      }

      if (product_type == 'dress-by-color') {
        $('.custom-dropdown .selected span').text(selected_options.dress_size);
      }
    }

    if (selected_options.dress_length != '') {
      $('.product-select--dress-length select').val(
        selected_options.dress_length
      );
    }

    setVariantID(selected_options.dress_size, selected_options.dress_length);
    handleEnableAddToCart();
  } else {
    selected_options.sku = current_sku;
    sessionStorage.setItem(
      'selected_options',
      JSON.stringify(selected_options)
    );
    handleEnableAddToCart();
  }

  // Init Tooltips
  if ($('.colorSelector').length > 0 || $('.exclusive-readonly').length > 0) {
    $('.tooltip').tooltipster({
      theme: 'tooltipster-noir',
      maxWidth: 250,
      animation: 'grow',
    });
  }

  if ($('.product-template__container').length > 0) {
    var alternatePaymentSliderOption = {
      vertical: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: false,
      infinite: true,
      dots: false,
      arrows: false,
      autoplay: true,
      speed: 2000,
      adaptiveHeight: true,
    };

    // Accessibility (WCAG 4.1.2): slick marks non-active slides
    // aria-hidden="true", but Affirm/Klarna inject focusable "learn more"
    // links into them ("aria-hidden contains focusable content"). Replace
    // aria-hidden with inert on this widget's hidden slides: same result for
    // screen readers and keyboard (inert also covers Klarna's shadow DOM),
    // no visual change.
    // NOTE: slick's ADA pass re-applies aria-hidden AFTER firing its
    // init/afterChange/setPosition events, so event handlers run too early.
    // A MutationObserver fires after every attribute write instead.
    var $paymentsSlider = $('.alternate-payments-slider');
    function swapPaymentsSliderAria() {
      $paymentsSlider.find('.slick-slide').each(function () {
        var $slide = $(this);
        if ($slide.attr('aria-hidden') === 'true') {
          $slide.removeAttr('aria-hidden').attr('inert', '');
        } else if ($slide.attr('aria-hidden') === 'false') {
          $slide.removeAttr('aria-hidden').removeAttr('inert');
        }
      });
    }
    var slider = $paymentsSlider.slick(alternatePaymentSliderOption);
    $paymentsSlider.each(function () {
      new MutationObserver(swapPaymentsSliderAria).observe(this, {
        attributes: true,
        subtree: true,
        attributeFilter: ['aria-hidden'],
      });
    });
    swapPaymentsSliderAria();

    // Thumbnail slider
    var slickOptions = {
      vertical: true,
      verticalSwiping: false,
      centerMode: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
    };

    let isSliding = false;

    var slickOptionsProductMain = {
      centerMode: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
    };

    // Do not init slick here for .image-main - let handleResponsiveScroll or showColorSlidesMobile do it
    var sliderMain = $('.image-main');

    var sliderProduct = $('.slider-main').slick(slickOptionsProductMain);
    if (window.innerWidth < 992) {
      console.log('init slick vertical');

      slider.on('beforeChange', function () {
        isSliding = true;
      });

      sliderMain.on('beforeChange', function () {
        isSliding = true;
      });
      sliderProduct.on('beforeChange', function () {
        isSliding = true;
      });
      slider.on('afterChange', function (event, slick, currentSlide) {
        isSliding = false;
        setSliderDotActive(currentSlide);
        slider.slick('slickGoTo', currentSlide);
      });

      sliderMain.on('afterChange', function (event, slick, currentSlide) {
        isSliding = false;
        setSliderDotActive(currentSlide);
        sliderMain.slick('slickGoTo', currentSlide);

        if ($(window).width() > 992) {
          const $imgMain = $('.image-main');
          const cleanup = $imgMain.data('scrollbar-cleanup');
          if (cleanup) {
            cleanup();
            setTimeout(initNativeScrollBar, 50);
          }
        }
      });

      sliderProduct.on('afterChange', function (event, slick, currentSlide) {
        isSliding = false;
        setSliderDotActive(currentSlide);
        sliderProduct.slick('slickGoTo', currentSlide);
      });
    }
    function initNativeScrollBar() {
      const $imgMain = $('.image-main');
      if (!$imgMain.length) return;
      if (
        !$('.product-template__container').length &&
        !$('.product-single').length
      ) {
        return;
      }

      if ($imgMain.hasClass('slick-initialized')) {
        $imgMain.slick('unslick');
      }

      const cleanup = $imgMain.data('scrollbar-cleanup');
      if (cleanup) cleanup();
      $('.desktop-scrollbar').remove();

      let selectedColor = '';

      const $activeSwatch = $('.swatch-element.active-swatch');
      if ($activeSwatch.length) {
        selectedColor = $activeSwatch.attr('data-colorname-value') || '';
      }

      if (!selectedColor && $imgMain.hasClass('slick-initialized')) {
        const currentSlide = $imgMain.slick('slickCurrentSlide');
        const $currentSlide = $imgMain.find('.slide').eq(currentSlide);
        selectedColor = $currentSlide.data('color') || '';
      }

      if (!selectedColor) {
        selectedColor = $imgMain.find('.slide').first().data('color') || '';
      }

      selectedColor = selectedColor.toString().toLowerCase();

      const $allSlides = $imgMain.find('.slide');
      const $visibleSlides = $allSlides.filter(function () {
        const color = ($(this).data('color') || '').toString().toLowerCase();
        return color === selectedColor;
      });

      const $noSwatchVisibleSlides = $allSlides.filter(function () {
        const color = ($(this).data('color') || '').toString().toLowerCase();
        return color !== '';
      });

      // Show/hide slides based on selected color, with fallback to show all if no matches
      // IMPORTANT: Do this BEFORE calculating visible count
      const hasMatchingSlides = $visibleSlides.length > 0;
      const isSingleColor = $('.swatch-element').length <= 1;
      $allSlides.each(function () {
        const slideColor = ($(this).data('color') || '')
          .toString()
          .toLowerCase();
        if (hasMatchingSlides) {
          if (slideColor === selectedColor) {
            $(this).show();
          } else if (!slideColor && isSingleColor) {
            // Single-color product: also show product.images (no data-color)
            $(this).show();
          } else {
            $(this).hide();
          }
        } else {
          // No matching color slides - show generic (no data-color) slides as fallback
          // Don't reveal server-hidden variant slides of other colors
          if (!slideColor) {
            $(this).show();
          }
        }
      });

      // Last resort: if nothing is visible at all, show everything
      if ($imgMain.find('.slide:visible').length === 0) {
        $allSlides.show();
      }

      // Count actually visible slides after filtering
      const $actuallyVisibleSlides = $imgMain.find('.slide:visible');
      const visibleColorCount = Math.max(1, $actuallyVisibleSlides.length);

      if (visibleColorCount <= 1) {
        return;
      }

      // Get first image - properly fallback if $visibleSlides is empty
      let $firstImg = $visibleSlides.length > 0
        ? $visibleSlides.first().find('img')
        : $noSwatchVisibleSlides.first().find('img');

      // If still no image found, try any visible slide
      if (!$firstImg || !$firstImg.length) {
        $firstImg = $actuallyVisibleSlides.first().find('img');
      }

      // If still nothing, try any slide at all
      if (!$firstImg || !$firstImg.length) {
        $firstImg = $allSlides.first().find('img');
      }

      let imageHeight = $firstImg.length ? ($firstImg.height() || $firstImg[0]?.naturalHeight || 0) : 0;
      const viewportHeight = $(window).height();

      // Determine which slides to size — prefer color-matched, fall back to all visible
      var $slidesToSize = $visibleSlides.length > 0 ? $visibleSlides : $actuallyVisibleSlides;

      // Only apply fixed heights if we have a valid image height
      if (imageHeight > 0) {
        $imgMain.css({
          overflowY: 'auto',
          overflowX: 'hidden',
          position: 'relative',
          scrollBehavior: 'smooth',
          border: 'none',
          outline: 'none',
          maxHeight: Math.min(imageHeight * visibleColorCount) + 'px',
        });

        $slidesToSize.css({
          display: 'block',
          width: '100%',
          height: imageHeight + 'px',
          flexShrink: 0,
        });
      } else {
        // Image not rendered yet - wait for it then reinitialize
        $imgMain.css({
          overflowY: 'auto',
          overflowX: 'hidden',
          position: 'relative',
        });
        if ($firstImg.length && $firstImg[0]) {
          if ($firstImg[0].complete) {
            // Already loaded but height was 0 (layout not ready) — retry shortly
            setTimeout(initNativeScrollBar, 150);
          } else {
            $firstImg.off('load.scrollbarInit').on('load.scrollbarInit', function() {
              setTimeout(initNativeScrollBar, 50);
            });
          }
        }
        return;
      }

      $imgMain[0].offsetHeight;

      const containerHeight = $imgMain.outerHeight();
      const scrollbarHeight = Math.min(300, containerHeight * 0.8);
      const thumbHeight = Math.max(20, scrollbarHeight / visibleColorCount);

      const $scrollbar = $(`
        <div class="desktop-scrollbar" style="
          position: absolute;
          left: 30px;
          top: 0;
          height: ${scrollbarHeight}px;
          width: 1px;
          border-radius: 2px;
          z-index: 10;
          opacity: 0;
          transition: opacity 0.2s ease;
        ">
          <div class="desktop-scrollbar-thumb" style="
            height: ${thumbHeight}px;
            width: 100%;
            border-radius: 2px;
            cursor: pointer;
            position: absolute;
            width: 1px;
            transition: all 0.3s ease;
            z-index: 2;
          "></div>
        </div>
      `);

      $imgMain.css('position', 'relative').append($scrollbar);
      // Fade in the scrollbar after append
      requestAnimationFrame(function () {
        $scrollbar.animate({ opacity: 1 }, 200);
      });
      const $thumb = $scrollbar.find('.desktop-scrollbar-thumb');
      // Utiliser la bonne liste d'images visibles (swatch ou non)
      function getGlobalVisibleSlides() {
        if ($visibleSlides.length > 0) return $visibleSlides;
        if ($noSwatchVisibleSlides.length > 0) return $noSwatchVisibleSlides;
        return $imgMain.find('.slide:visible');
      }

      function updateThumbPosition() {
        let closestIndex = 0;
        let minDiff = Infinity;
        const pageScrollTop =
          window.scrollY || document.documentElement.scrollTop;
        const $globalSlides = getGlobalVisibleSlides();
        $globalSlides.each(function (index) {
          const slideRect = this.getBoundingClientRect();
          const slideTopAbs = pageScrollTop + slideRect.top;
          const diff = Math.abs(pageScrollTop - slideTopAbs);
          if (diff < minDiff) {
            minDiff = diff;
            closestIndex = index;
          }
        });
        let thumbTop = 0;
        if (visibleColorCount > 1) {
          const segmentHeight =
            (scrollbarHeight - thumbHeight) / (visibleColorCount - 1);
          thumbTop = closestIndex * segmentHeight;
        }
        $thumb.css('top', `${thumbTop}px`);
      }

      // Second level menu scroll animation - perfectly smooth
      (function() {
        let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        let isHidden = false;
        let ticking = false;
        let scrollTimeout;
        const $secondLevelMenu = $('.second-level-menu');

        if (!$secondLevelMenu.length) return;

        function updateMenu() {
          const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const scrollDelta = currentScrollTop - lastScrollTop;

          // Clear any pending timeout
          clearTimeout(scrollTimeout);

          // Wait a bit after scroll stops to make final decision
          scrollTimeout = setTimeout(function() {
            if (scrollDelta > 10 && currentScrollTop > 100 && !isHidden) {
              // Scrolling down - hide
              $secondLevelMenu.addClass('menu-hidden');
              isHidden = true;
            } else if (scrollDelta < -10 && isHidden) {
              // Scrolling up - show
              $secondLevelMenu.removeClass('menu-hidden');
              isHidden = false;
            }

            lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
          }, 50);

          ticking = false;
        }

        $(window).on('scroll.secondNav', function() {
          if (!ticking) {
            window.requestAnimationFrame(updateMenu);
            ticking = true;
          }
        });
      })();

      function scrollToImage(index) {
        const $globalSlides = getGlobalVisibleSlides();
        const $target = $globalSlides.eq(index);
        if ($target.length) {
          const header = $('header');
          const headerHeight = header.length ? header.outerHeight() : 0;
          const targetRect = $target[0].getBoundingClientRect();
          const pageScrollTop =
            window.scrollY || document.documentElement.scrollTop;
          const targetTopAbs = pageScrollTop + targetRect.top;
          const scrollTo = Math.max(0, targetTopAbs - headerHeight - 20);
          window.scrollTo({ top: scrollTo, behavior: 'smooth' });
          setTimeout(function () {
            updateThumbPosition();
          }, 300);
        }
      }

      function updateScrollbarPosition() {
        const pageScrollTop = $(window).scrollTop();
        const containerRect = $imgMain[0].getBoundingClientRect();
        const containerTop = containerRect.top + pageScrollTop;
        const containerHeight = containerRect.height;
        const viewportHeight = $(window).height();

        let visibleTop = Math.max(0, pageScrollTop - containerTop);
        let visibleBottom = Math.min(
          containerHeight,
          pageScrollTop + viewportHeight - containerTop
        );
        let visibleHeight = Math.max(0, visibleBottom - visibleTop);

          if (visibleHeight > 0) {
          let scrollbarTop;
          const $globalSlides = getGlobalVisibleSlides();
          const firstSlide = $globalSlides[0];
          const lastSlide = $globalSlides[$globalSlides.length - 1];
          const bottomPadding = 50;
          if (firstSlide) {
            const firstSlideRect = firstSlide.getBoundingClientRect();
            const header = $('header');
            const headerHeight = header.length ? header.outerHeight() : 0;
            const baseTop = visibleTop + (firstSlideRect.height - scrollbarHeight) / 2;
            scrollbarTop = baseTop;
          } else {
            scrollbarTop = visibleTop;
          }

          if (lastSlide) {
            const lastRect = lastSlide.getBoundingClientRect();
            const lastBottomAbs = pageScrollTop + lastRect.top + lastRect.height;
            const containerAbsTop = containerTop;
            const maxTop = Math.max(0, (lastBottomAbs - containerAbsTop) - scrollbarHeight - bottomPadding);
            scrollbarTop = Math.max(0, Math.min(scrollbarTop, maxTop));
          } else {
            scrollbarTop = Math.max(0, scrollbarTop);
          }

          $scrollbar.css('top', scrollbarTop + 'px');
          $scrollbar.css('opacity', 1);
        } else {
          $scrollbar.css('opacity', 0);
        }
      }

      // Store function for external access
      $imgMain.data('scrollbar-update-thumb', updateThumbPosition);
      $imgMain.data('scrollbar-update-position', updateScrollbarPosition);

      // Synchroniser le thumb avec le scroll global de la page
      $(window)
        .off('scroll.customScrollbar')
        .on('scroll.customScrollbar', function () {
          updateThumbPosition();
          updateScrollbarPosition();
        });

      $scrollbar.on('click.customScrollbar', function (e) {
        const rect = this.getBoundingClientRect();
        const clickY = e.clientY - rect.top;
        console.log('Scrollbar clicked at Y:', visibleColorCount);
        const segmentHeight =
          (scrollbarHeight - thumbHeight) / (visibleColorCount - 1);
        let index = Math.round(clickY / segmentHeight);
        index = Math.max(0, Math.min(visibleColorCount - 1, index));
        scrollToImage(index);
      });

      let isDragging = false,
        startY = 0,
        startThumbTop;
      $thumb.on('mousedown.customScrollbar', function (e) {
        e.preventDefault();
        isDragging = true;
        startY = e.clientY;
        startThumbTop = parseFloat($thumb.css('top'));
        $(document.body).addClass('dragging');
      });
      $(document).on('mousemove.customScrollbarDrag', function (e) {
        if (!isDragging) return;
        const deltaY = e.clientY - startY;
        const segmentHeight =
          (scrollbarHeight - thumbHeight) / (visibleColorCount - 1);
        let newThumbTop = Math.max(
          0,
          Math.min(scrollbarHeight - thumbHeight, startThumbTop + deltaY)
        );
        let index = Math.round(newThumbTop / segmentHeight);
        index = Math.max(0, Math.min(visibleColorCount - 1, index));
        $thumb.css('top', `${index * segmentHeight}px`);
        scrollToImage(index);
      });
      $(document).on('mouseup.customScrollbarDrag', function () {
        if (!isDragging) return;
        isDragging = false;
        $(document.body).removeClass('dragging');
      });

      $imgMain.data('scrollbar-scroll-to-image', scrollToImage);
      // Hover effects

      // Initial update
      setTimeout(function () {
        updateThumbPosition();
        updateScrollbarPosition();
      }, 100);

      // Update on image load
      $visibleSlides.find('img').on('load.customScrollbar', function () {
        setTimeout(function () {
          updateThumbPosition();
          updateScrollbarPosition();
        }, 200);
      });

      // Cleanup function
      $imgMain.data('scrollbar-cleanup', function () {
        $imgMain.off('.customScrollbar');
        $(window).off('.customScrollbar');
        $(document).off('.customScrollbarDrag');
        $scrollbar.remove();

        // Reset container styles
        $imgMain.css({
          height: '',
          maxHeight: '',
          overflowY: '',
          overflowX: '',
          position: '',
          scrollBehavior: '',
          border: '',
          outline: '',
        });

        // Reset slide dimension styles (keep display state for initNativeScrollBar to handle)
        $allSlides.css({
            width: '',
            minHeight: '',
            marginBottom: '',
          });
      });

      // opacity reveal handled by safety timeout
    }

    function handleResponsiveScroll() {
      const $imgMain = $('.image-main');

      if ($(window).width() > 992) {
        // Only initialize on product pages
        if (
          $('.product-template__container').length ||
          $('.product-single').length
        ) {
          // Cleanup old scrollbar first
          const cleanup = $imgMain.data('scrollbar-cleanup');
          if (cleanup) cleanup();

          // Check if we have multiple images for the selected color
          let selectedColor =
            $('.swatch-element.active-swatch').attr('data-colorname-value') ||
            '';
          selectedColor = selectedColor.toString().toLowerCase();

          const $visibleSlides = $imgMain.find('.slide').filter(function () {
            const color = ($(this).data('color') || '')
              .toString()
              .toLowerCase();
            return color === selectedColor;
          });
          const $noSwatchVisibleSlides = $imgMain
            .find('.slide')
            .filter(function () {
              const color = ($(this).data('color') || '')
                .toString()
                .toLowerCase();
              return color !== '';
            });
          console.log(
            'Visible slides for color',
            selectedColor,
            ':',
            $visibleSlides.length
          );
          if ($visibleSlides.length > 1 || $noSwatchVisibleSlides.length > 1 || $imgMain.find('.slide').length > 1) {
            setTimeout(initNativeScrollBar, 100);
          }
        }
      } else {
        const cleanup = $imgMain.data('scrollbar-cleanup');
        if (cleanup) cleanup();

        if (!$imgMain.hasClass('slick-initialized')) {
          // Use showColorSlidesMobile instead of direct init
          const activeColor = $('.swatch-element.active-swatch').attr('data-colorname-value') || '';
          if (activeColor) {
            showColorSlidesMobile(activeColor);
          } else {
            $imgMain.slick(slickOptionsMain);
            $imgMain.find('.slick-slide[aria-hidden="true"]').attr('inert', '');
            setTimeout(syncDotsWidth, 100);
          }
        }
      }
    }

    // If mobile, show slides for the active swatch immediately
    try {
      const activeColor = $('.swatch-element.active-swatch').attr('data-colorname-value') || '';
      if ($(window).width() < 992) {
        showColorSlidesMobile(activeColor);
      }
    } catch (e) {
      // ignore
    }
    handleResponsiveScroll();
    $(window).on('resize', handleResponsiveScroll);
    $(window).on('load', handleResponsiveScroll);
    // Single reveal point: wait for all JS init to settle, then reveal images
    setTimeout(function() {
      $('body').addClass('images-loaded');
      $(window).trigger('scroll');
    }, 1200);
    $('.control-down').on('click', function () {
      if (isSliding) {
        return;
      }

      if ($(window).width() > 992) {
        const $imgMain = $('.image-main');
        const scrollToImage = $imgMain.data('scrollbar-scroll-to-image');
        if (scrollToImage) {
          const selectedColor =
            $('.swatch-element.active-swatch').attr('data-colorname-value') ||
            '';
          const $visibleSlides = $imgMain.find('.slide').filter(function () {
            const color = ($(this).data('color') || '')
              .toString()
              .toLowerCase();
            return color === selectedColor.toLowerCase();
          });
          const $noSwatchVisibleSlides = $imgMain
            .find('.slide')
            .filter(function () {
              const color = ($(this).data('color') || '')
                .toString()
                .toLowerCase();
              return color !== '';
            });
          const currentScrollTop = $imgMain.scrollTop();
          let currentIndex = 0;

          // Find current image index
          $visibleSlides.each(function (index) {
            const slideTop = $(this).position().top + $imgMain.scrollTop();
            if (slideTop <= currentScrollTop + 50) {
              currentIndex = index;
            }
          });
          $noSwatchVisibleSlides.each(function (index) {
            const slideTop = $(this).position().top + $imgMain.scrollTop();
            if (slideTop <= currentScrollTop + 50) {
              currentIndex = index;
            }
          });

          const nextIndex = Math.min(
            currentIndex + 1,
            $noSwatchVisibleSlides.length - 1 || $visibleSlides.length - 1
          );
          scrollToImage(nextIndex);
        }
      } else {
        // Mobile: use Slick
        slider.slick('next');
        sliderMain.slick('next');
        sliderProduct.slick('next');
      }
    });

    $('.control-up').on('click', function () {
      if (isSliding) {
        return;
      }

      if ($(window).width() > 992) {
        const $imgMain = $('.image-main');
        const scrollToImage = $imgMain.data('scrollbar-scroll-to-image');
        if (scrollToImage) {
          const selectedColor =
            $('.swatch-element.active-swatch').attr('data-colorname-value') ||
            '';
          const $visibleSlides = $imgMain.find('.slide').filter(function () {
            const color = ($(this).data('color') || '')
              .toString()
              .toLowerCase();
            return color === selectedColor.toLowerCase();
          });

          const currentScrollTop = $imgMain.scrollTop();
          let currentIndex = 0;

          $visibleSlides.each(function (index) {
            const slideTop = $(this).position().top + $imgMain.scrollTop();
            if (slideTop <= currentScrollTop + 50) {
              currentIndex = index;
            }
          });

          const prevIndex = Math.max(currentIndex - 1, 0);
          scrollToImage(prevIndex);
        }
      } else {
        // Mobile: use Slick
        slider.slick('prev');
        sliderMain.slick('prev');
        sliderProduct.slick('prev');
      }
    });

    var swatch = {
      elements: $('.swatch-element'),
    };
    var _lastSwatchClickTime = 0;
    var _lastSwatchClickEl = null;
    swatch.elements.on('click keyup', function (e) {
      if (e.type === 'click' || (e.type === 'keyup' && e.keyCode === 13)) {
        // Guard: label→input click forwarding causes this handler to fire twice
        // per physical click. Skip only the second (forwarded) event on the SAME
        // swatch — must check element identity too, otherwise a genuine fast click
        // on a DIFFERENT swatch within 300ms gets silently dropped.
        var now = Date.now();
        if (this === _lastSwatchClickEl && now - _lastSwatchClickTime < 300) return;
        _lastSwatchClickTime = now;
        _lastSwatchClickEl = this;
        const selected_swatch = $(this)
          .attr('data-colorname-value')
          .toLowerCase();
        swatch.elements.each(function () {
          $(this).removeClass('active-swatch');
        });

        selected_options.dress_size = '';
        selected_options.dress_length = '';
        selected_options.color = selected_swatch;

        sessionStorage.setItem(
          'selected_options',
          JSON.stringify(selected_options)
        );
        handleEnableAddToCart();

        $('.product-select--size select').val('').trigger('change');
        $('.product-select--dress-length select').val('').trigger('change');
        $('.custom-dropdown .selected span.current-selected-value').text('');

        // RTS products: redirect immediately, skip animation work
        if (product_is_ready_to_ship === 'true') {
          var rtsRedirectLink = $(this).attr('data-rts-redirect-link');
          if (rtsRedirectLink) {
            selected_options = {
              sku: '',
              dress_size: '',
              dress_length: '',
              color: '',
            };
            sessionStorage.setItem(
              'selected_options',
              JSON.stringify(selected_options)
            );
            window.location = rtsRedirectLink;
            return;
          }
        }

        if (is_rtw == 'true') {
          fetchProductAndInventoryData(selected_swatch);
        }

        $('.swatch-element').removeClass('active-swatch');
        $(this).addClass('active-swatch');

        if ($(window).width() > 992) {
          // Desktop: fade out, swap slides, fade in
          const imgMain = $('.image-main');
          const $scrollbar = imgMain.find('.desktop-scrollbar');
          const $slides = imgMain.find('.slide img');
          const cleanup = imgMain.data('scrollbar-cleanup');
          if (cleanup) cleanup();

          $scrollbar.css({ transition: 'opacity 0.15s ease', opacity: 0 });
          $slides.css({ transition: 'opacity 0.15s ease', opacity: 0 });

          const swatchEl = this;
          setTimeout(function () {
            $scrollbar.remove();

            var colorVal = $(swatchEl).attr('data-colorname-value') || '';

            // Try to rebuild slides from cached original HTML
            try {
              showColorSlidesMobile(colorVal);
            } catch (err) {
              console.warn('showColorSlidesMobile error', err);
            }

            // Fallback: if showColorSlidesMobile didn't replace slides
            // (e.g. no cached HTML), manually show/hide slides by color
            var colorLower = colorVal.toLowerCase();
            var $allSlides = imgMain.find('.slide');
            var hasMatchingColor = false;
            $allSlides.each(function () {
              var sc = ($(this).data('color') || '').toString().toLowerCase();
              if (sc === colorLower) {
                $(this).show();
                hasMatchingColor = true;
              } else if (sc) {
                $(this).hide();
              }
            });
            if (!hasMatchingColor) {
              $allSlides.show();
            }

            // Fade in the now-visible slides
            var $newSlides = imgMain.find('.slide:visible img');
            $newSlides.css({ opacity: 0 });
            requestAnimationFrame(function () {
              $newSlides.css({ transition: 'opacity 0.3s ease', opacity: 1 });
            });

            // Scroll to top of images and reinit scrollbar
            setTimeout(function () {
              var header = $('header');
              var headerHeight = header.outerHeight();
              var imgMainOffset = imgMain.offset().top;
              window.scrollTo({
                top: imgMainOffset - headerHeight - 20,
                behavior: 'smooth',
              });
              setTimeout(initNativeScrollBar, 250);
            }, 50);
          }, 200);
        } else {
          // Mobile: fade out container, rebuild slider, then fade in
          var $mobileMain = $('.image-main');
          $mobileMain.css({ transition: 'opacity 0.15s ease', opacity: 0 });
          var mobileSwatchEl = this;
          setTimeout(function () {
            // Unslick
            if ($mobileMain.hasClass('slick-initialized')) {
              try { $mobileMain.slick('unslick'); } catch (e) {}
            }

            // Rebuild slides from original HTML filtered by color
            var colorVal = $(mobileSwatchEl).attr('data-colorname-value') || '';
            var originalHtml = $mobileMain.data('original-slides-html');
            if (originalHtml) {
              var $temp = $('<div>').html(originalHtml);
              var target = colorVal.toLowerCase();
              var $filtered = $temp.find('.slide').filter(function () {
                return ($(this).data('color') || '').toString().toLowerCase() === target;
              });
              var $finalSlides = $filtered.length ? $filtered : $temp.find('.slide');
              $finalSlides.removeAttr('style');
              $mobileMain.empty().append($finalSlides);
              $mobileMain.find('.slick-cloned').remove();
            }

            // Init slick synchronously, then fade in
            try {
              if (!$mobileMain.hasClass('slick-initialized')) {
                $mobileMain.slick(slickOptionsMain);
              }
            } catch (e) {}
            $mobileMain.find('.slick-slide[aria-hidden="true"]').attr('inert', '');

            requestAnimationFrame(function () {
              $mobileMain.css({ transition: 'opacity 0.3s ease', opacity: 1 });
              setTimeout(syncDotsWidth, 100);
            });
          }, 180);
        }
      }
    });

    // Handle Quantity input Add/Substract events
    const quantity_input = $('input.product-form__qty');
    $('button.quantity-btn').on('click', function (e) {
      e.preventDefault();
      let current_quantity = quantity_input.val();

      if ($(this).hasClass('add-qty')) {
        current_quantity++;
      } else {
        current_quantity--;
      }
      if (current_quantity <= 0) {
        current_quantity = 1;
      }

      quantity_input.val(current_quantity);
      return false;
    });

    let is_boldmetrics =
      $('input[type=hidden]#hidden-product-boldmetrics-enabled').val() ===
      'true';
    if ($('.size-chart-link-popup, .size-chart-open-popup').length > 0) {
      $('.size-chart-link-popup, .size-chart-open-popup').magnificPopup({
        type: 'inline',
        midClick: true,
      });

      if (is_boldmetrics) {
        $('.fit-link-modal').on('click', function (e) {
          e.preventDefault();
          $('.boldmetrics-ssc-button, #ssc-boldmetrics-activator').click();
          return false;
        });
      }
    }

    // Delivery Date Service
    const collectionName = $(
      'input[type=hidden]#hidden-product-collection'
    ).val();

    $(document).ready(function () {
      // Check if product has bridal tag and MTO template
      const eta_date_element = $(
        '.estimated-delivery-date p#delivery_service_desc'
      );
      const hasMetafieldDate = eta_date_element.data('metafield-date');
      const isBridalMTO = eta_date_element.data('is-bridal-mto') === true;
      const hasBridalTag = eta_date_element.data('has-bridal-tag') === 'true';
      const hasAccessoryTag = eta_date_element.data('has-accessory-tag') === 'true';
      
      // Calculate bridal/accessory MTO date if applicable
      let customMTODate = null;
      if ((isBridalMTO || hasBridalTag || hasAccessoryTag) && !hasMetafieldDate) {
        const today = new Date();
        // Add 12 weeks (84 days)
        const targetDate = new Date(today.getTime() + (84 * 24 * 60 * 60 * 1000));
        
        // Defer to next business day if falls on weekend
        const dayOfWeek = targetDate.getDay();
        if (dayOfWeek === 0) { // Sunday
          targetDate.setDate(targetDate.getDate() + 1);
        } else if (dayOfWeek === 6) { // Saturday
          targetDate.setDate(targetDate.getDate() + 2);
        }
        
        customMTODate = moment(targetDate).format('L');
      }
console.log('Custom MTO Date:', customMTODate);
console.log('Metafield Date:', eta_date_element.data('metafield-date'));
console.log('Is Bridal MTO:', isBridalMTO);
      $.ajax({
        url:
          'https://store.b2b.amsale.com/delivery_date_check/' +
          collectionName +
          '?platform=b2c',
        context: document.body,
        success: function (data) {
          var currentDate = new Date(data.value.toString());
          var formattedDate = moment.utc(currentDate).format('L');
          const hidden_eta_input = $('#hidden-product-estimated-date');
          const is_holiday =
            $('.estimated-delivery-date.is-holiday-date').length > 0;
          
          // Use custom MTO date if applicable, otherwise use API date
          const finalFormattedDate = customMTODate || formattedDate;
          eta_date_element.attr('data-mto-date', finalFormattedDate);
console.log('Final Formatted Date:', finalFormattedDate);
          const metafieldDate = eta_date_element.data('metafield-date');

          if (metafieldDate) {
            // Check if metafield date is in the past
            const metafieldDateObj = new Date(metafieldDate);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            
            if (metafieldDateObj < today) {
              // Use fallback dates if metafield date is passed
              if (!is_holiday) {
                eta_date_element.find('span.delivery-date').text(finalFormattedDate);
                hidden_eta_input.val(finalFormattedDate);
              } else {
                hidden_eta_input.val(eta_date_element.data()?.holidayDate);
              }
            } else {
              hidden_eta_input.val(metafieldDate);
            }
          } else if (!is_holiday) {
            eta_date_element.find('span.delivery-date').text(finalFormattedDate);
            hidden_eta_input.val(eta_date_element.data()?.mtoDate);
          } else {
            hidden_eta_input.val(eta_date_element.data()?.holidayDate);
          }
        },
        error: function (msg) {
          console.log('status', msg.status);
          console.log('statusText', msg.statusText);
        },
      });
    });

    // Add to Cart Submit Click Handler
    $('button[type=submit].product-form__cart-submit').on(
      'click',
      function (e) {
        if ($('.colorSelector').length > 0) {
          if ($('.swatch-element.active-swatch').length <= 0) {
            e.preventDefault();
            displayUserFeedbackMessage(
              'error',
              'Color missing',
              'Please select a color.'
            );
            return false;
          }
        }

        if ($('.custom-ddlist').length > 0) {
          if (
            $('.custom-ddlist .custom-dropdown .selected span').html() === ''
          ) {
            e.preventDefault();
            displayUserFeedbackMessage(
              'error',
              'Size missing',
              'Please select a size.'
            );
            return false;
          }
        }

        if ($('form.product-form .product-select--size select').length > 0) {
          if ($('.product-select--size select').val() == '') {
            e.preventDefault();
            displayUserFeedbackMessage(
              'error',
              'Size missing',
              'Please select a size.'
            );
            return false;
          }
        }
        if (
          infiniteOptionsSizeSelect &&
          infiniteOptionsSizeSelect?.html().length > 0
        ) {
          if ($('.spb-select select').val() == '') {
            e.preventDefault();
            $('#infiniteoptions-container').addClass('select-error');
            displayUserFeedbackMessage(
              'error',
              'Size missing',
              'Please select a size.'
            );
            return false;
          }
        }

        if (
          $('form.product-form .product-select--dress-length select').length > 0
        ) {
          if ($('.product-select--dress-length select').val() == '') {
            e.preventDefault();
            displayUserFeedbackMessage(
              'error',
              'Dress Length missing',
              'Please select a length.'
            );
            return false;
          }
        }
      }
    );

    document.arrive('.infinite-option-size-select select', function () {
      if (product_is_ready_to_ship == 'true' && product_type == 'dress') {
        $(this).prop('disabled', true);
      } else {
        if (selected_options.color != '') {
          $(this).prop('disabled', false);
        }

        if (selected_options.dress_size != '') {
          $(this).val(selected_options.dress_size);
          $(this).prop('disabled', false);
        }
      }

      handleEnableAddToCart();
    });

    $(document).on(
      'change',
      '.infinite-option-size-select select',
      function () {
        if (document.readyState == 'complete') {
          if ($(this).val() != '') {
            $('#infiniteoptions-container').removeClass('select-error');
          }

          selected_options.dress_size = $(this).val();
          sessionStorage.setItem(
            'selected_options',
            JSON.stringify(selected_options)
          );
          handleEnableAddToCart();
        }
      }
    );

    $(document).on('change', '.product-select--size select', function () {
      if (document.readyState == 'complete') {
        selected_options.dress_size = $(this).val();
        sessionStorage.setItem(
          'selected_options',
          JSON.stringify(selected_options)
        );
        handleEnableAddToCart();
      }
    });

    $(document).on(
      'change',
      '.product-select--dress-length select',
      function () {
        if (document.readyState == 'complete') {
          selected_options.dress_length = $(this).val();
          sessionStorage.setItem(
            'selected_options',
            JSON.stringify(selected_options)
          );
          setVariantID(selected_options.dress_size, selected_options.dress_length);
          const selectedVariantId = $('select.product-form__variants').val();
          if (selectedVariantId) {
            const productJsonEl = document.querySelector('[id^="ProductJson-"]');
            if (productJsonEl) {
              try {
                const productJson = JSON.parse(productJsonEl.textContent);
                const variant = productJson.variants.find((v) => String(v.id) === String(selectedVariantId));
                if (variant && typeof theme !== 'undefined' && theme.Currency) {
                  if (variant.compare_at_price > variant.price) {
                    $('[data-regular-price]').html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
                    $('[data-sale-price]').html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
                    $('[data-price]').addClass('price--on-sale');
                  } else {
                    $('[data-regular-price]').html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
                    $('[data-price]').removeClass('price--on-sale');
                  }
                }
              } catch (e) {}
            }
          }
          handleEnableAddToCart();
        }
      }
    );

    // Custom Ready-to-Ship Dropdown Events
    const custom_select = $('.custom-dropdown .selected');
    const down_arrow = $('.custom-dropdown .selected svg');
    custom_select.on('click keypress', function (e) {
      const dropdown = $(this).next();

      if (dropdown.is(':visible')) {
        dropdown.hide();
        down_arrow.removeClass('active');
      } else {
        dropdown.show();
        down_arrow.addClass('active');
      }
    });

    $(document).bind('click', function (e) {
      var $clicked = $(e.target);
      if (!$clicked.parents().hasClass('custom-dropdown')) {
        custom_select.next().hide();
      }
    });

    $(document).on('keyup', function (evt) {
      if (evt.keyCode == 27) {
        custom_select.next().hide();
      }
    });

    $(document).on(
      'click keypress',
      '.custom-dropdown .ddlist-options ul li',
      function () {
        $('.custom-dropdown .ddlist-options ul li').removeClass(
          'active-selection'
        );
        const AddToCartButton = $('button.product-form__cart-submit');
        const klaviyoButton = $('button.klaviyo_popup_trigger');
        if (!$(this).hasClass('disabled')) {
          $(this).addClass('active-selection');
          const hidden_eta_input = $('#hidden-product-estimated-date');
          const hidden_saletype = $(
            'input[type=hidden]#product-properties-saletype'
          );
          const eta_date_element = $(
            '.estimated-delivery-date p#delivery_service_desc'
          );
          const is_holiday =
            $('.estimated-delivery-date.is-holiday-date').length > 0;
          const is_pre_order = $('input[type=hidden]#hidden-is-preorder').val();

          if ($(this).hasClass('rts')) {
            if (is_pre_order) {
              hidden_saletype.val('Pre-Order');
              const metafieldDate = eta_date_element.data('metafieldDate');
              if (metafieldDate) {
                hidden_eta_input.val(metafieldDate);
              }
              AddToCartButton.show();
              klaviyoButton.hide();
            } else {
              hidden_eta_input.val(eta_date_element.data().instockDate);
              hidden_saletype.val('In Stock');
              AddToCartButton.show();
              klaviyoButton.hide();
            }
          } else {
            if ($(this).hasClass('rtw')) {
              AddToCartButton.hide();
              klaviyoButton.show();
            }
            if (!is_holiday) {
              hidden_eta_input.val(eta_date_element.data().mtoDate);
            } else {
              hidden_eta_input.val(eta_date_element.data().holidayDate);
            }
            hidden_saletype.val('Made to Order');
          }

          custom_select
            .find('span.current-selected-value')
            .text($(this).find('span.variant-value').text());
          custom_select.next().hide();
          $('.product-select--size select')
            .val($(this).find('span.variant-value').text())
            .change();
          $('.product-form__variants').val($(this).data('variant-id'));
          let url = new URL(window.location.href);
          url.searchParams.set('variant', $(this).data('variant-id'));
          window.history.replaceState(null, null, url);
        }
      }
    );

    if ($('.product-select--RTS').length > 0) {
      const product_id = $('.custom-dropdown .ddlist-options ul').data(
        'product-id'
      );
      if (product_id) {
        const active_swatch = $('.swatch-element.active-swatch');
        let active_color = null;

        if (active_swatch.length > 0) {
          active_color = active_swatch.attr('data-colorname-value');
          if (active_color) {
            active_color = active_color.toLowerCase();
          }
        }

        const api_endpoint = `https://api.ecom.amsale.com/api/inventory/${product_id}`;

        const productHandle = window.location.pathname.split('/').pop();
        const productJsonUrl = `/products/${productHandle}.json`;

        Promise.all([
          fetch(api_endpoint).then(r => r.json()),
          fetch(productJsonUrl).then(r => r.json())
        ]).then(([data, shopifyData]) => {
          if (data && data.inventory && data.inventory.length > 0) {
            if (is_rtw === 'true' && active_color) {
              fetchProductAndInventoryData(active_color);
            }
            generateDropdownHTML(data.inventory, shopifyData || null, active_color);
          } else {
            console.warn('No valid inventory data received.');
          }
          $('.custom-dropdown span.loading-data').removeClass('loading');
        }).catch(() => {
          displayUserFeedbackMessage(
            'error',
            'Error',
            'Sorry. An error occurred.<br>Please refresh the page<br>and try again.'
          );
        });
      }
    }
  }
  // Fermeture du if ($('.product-template__container').length > 0)
});

// ============================================
// UTILITY FUNCTIONS
// ============================================

function setSliderDotActive(goToIndex) {
  const active_index = parseInt($('.slider-dot.active').data('slide-index'));
  $('.slider-dot').eq(active_index).removeClass('active');
  $('.slider-dot').eq(goToIndex).addClass('active');
}

function setSwatchSelectValue(value) {
  $('.product-select--color select.single-option-selector')
    .val(capitalizeFirstLetters(value))
    .trigger('change');
}

function capitalizeFirstLetters(str) {
  return str
    .split('-')
    .map(function (item) {
      return item.charAt(0).toUpperCase() + item.slice(1);
    })
    .join('-');
}

function handleEnableAddToCart() {
  const size_select =
    $('.infinite-option-size-select select').length > 0
      ? $('.infinite-option-size-select select')
      : $('.product-select--size select');
  const length_select = $('.product-select--dress-length select');
  const swatch_selectors = $('.colorSelector');
  const collectionName = $(
    'input[type=hidden]#hidden-product-collection'
  ).val();
  let valid_state = false;

  if (
    swatch_selectors.length == 0 &&
    size_select.length == 0 &&
    length_select.length == 0
  ) {
    valid_state = true;
  } else if (
    swatch_selectors.length > 0 &&
    size_select.length == 0 &&
    length_select.length == 0
  ) {
    if (swatch_selectors.find('.active-swatch').length > 0) {
      valid_state = true;
    }
  } else if (
    swatch_selectors.length > 0 &&
    size_select.length > 0 &&
    length_select.length > 0
  ) {
    if (
      swatch_selectors.find('.active-swatch').length > 0 &&
      size_select.val() != '' &&
      length_select.val() != ''
    ) {
      valid_state = true;
    }
  } else if (
    swatch_selectors.length > 0 &&
    size_select.length > 0 &&
    length_select.length == 0
  ) {
    if (
      swatch_selectors.find('.active-swatch').length > 0 &&
      size_select.val() != ''
    ) {
      valid_state = true;
    }
  } else if (
    swatch_selectors.length == 0 &&
    size_select.length > 0 &&
    length_select.length == 0
  ) {
    if (size_select.val() != '') {
      valid_state = true;
    }
  } else if (
    swatch_selectors.length == 0 &&
    size_select.length > 0 &&
    length_select.length > 0
  ) {
    if (size_select.val() != '' && length_select.val() != '') {
      valid_state = true;
    }
  }

  if (
    $('.product__price dd span.price-item--regular')
      .text()
      .includes('Sold out') ||
    $('button.product-form__cart-submit span').text().includes('Sold out')
  ) {
    valid_state = true;
  }

  if (valid_state) {
    $('button.product-form__cart-submit').prop('disabled', false);
  } else if (!valid_state && collectionName === 'private-sale') {
    $('button.product-form__cart-submit').prop('disabled', true);
  }
}

function getCurrentColor() {
  let element = null;

  if ($('.colorSelector').length > 0) {
    element = $('.colorSelector');
  } else if ($('.product-form__selects.product-select--color').length > 0) {
    element = $('.product-form__selects.product-select--color');
  }

  if (element) {
    if (element.hasClass('colorSelector')) {
      return element.find('.active-swatch').attr('data-colorname-value');
    } else {
      return element.find('select.single-option-selector').val();
    }
  }

  return false;
}

function escapeRegExpMatch(s) {
  return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

function isExactMatch(str, match) {
  return new RegExp(`\\b${escapeRegExpMatch(match)}\\b`).test(str);
}

function setVariantID(dress_size, dress_length) {
  let full_search_query = '';

  if (getCurrentColor() !== false && dress_size !== '' && dress_length !== '') {
    if ($('.product-form__selects.product-select--size').length > 0) {
      full_search_query = `${getCurrentColor()} / ${dress_size} / ${dress_length}`;
    } else {
      full_search_query = `${getCurrentColor()} / ${dress_length}`;
    }
  } else if (
    getCurrentColor() !== false &&
    dress_size == '' &&
    dress_length !== ''
  ) {
    full_search_query = `${getCurrentColor()} / ${dress_length}`;
  } else if (
    getCurrentColor() !== false &&
    dress_size !== '' &&
    dress_length == ''
  ) {
    if ($('.product-form__selects.product-select--size').length > 0) {
      full_search_query = `${getCurrentColor()} / ${dress_size}`;
    } else {
      full_search_query = getCurrentColor();
    }
  } else if (
    getCurrentColor() !== false &&
    dress_size == '' &&
    dress_length == ''
  ) {
    full_search_query = getCurrentColor();
  } else if (getCurrentColor() == false && dress_size !== '') {
    full_search_query = dress_size;
  }

  if (full_search_query !== '') {
    $('select.product-form__variants option').each(function () {
      if (isExactMatch(full_search_query, $(this).text())) {
        $('select.product-form__variants').val($(this).val()).trigger('change');
      }
    });
  }
}

function setGlobalSkuOnClick(sku) {
  if ($('#hidden-is-rtw').val()) {
    $('#hidden-product-sku').val(sku);
  }
}

function generateDropdownHTML(
  inventoryData,
  productData = null,
  selectedColor = null
) {
  if (!inventoryData || inventoryData.length === 0) {
    console.warn('⚠ No inventory data found!');
    return;
  }
  const is_pre_order = $('input[type=hidden]#hidden-is-preorder').val();
  const custom_ddl = $('.custom-dropdown .ddlist-options ul');
  const soldout = custom_ddl.data('sold-out');
  const rtw = productData?.product?.template_suffix;
  let DDL_html = '';
  let addedSizes = new Set();

  // Build a lookup of inventory availability by variant_id
  const inventoryLookup = {};
  inventoryData.forEach((item) => {
    if (item.location?.includes('318')) {
      inventoryLookup[item.variant_id] = item.available;
    }
  });

  // If we have Shopify product data, use its variants as source of truth for sizes
  if (productData && productData.product && productData.product.variants) {
    const variants = productData.product.variants;
    variants.forEach((variant) => {
      const size = variant.option2;
      const color = variant.option1;
      const dressLength = variant.option3;

      // Skip non-standard lengths, MM and SS sizes
      if (['XL', 'SS', 'MM'].includes(size)) return;
      if (dressLength && dressLength !== 'Standard') return;

      // Filter by color if specified
      if (selectedColor && color.toLowerCase() !== selectedColor.toLowerCase()) return;

      let sizeKey = `${size}-${color}`;
      if (addedSizes.has(sizeKey)) return;

      const available = inventoryLookup[variant.id] === true;
      let listItemClass = available
        ? 'option rts'
        : soldout && rtw
        ? 'option rtw'
        : 'option mto';
      let statusText = available
        ? is_pre_order
          ? 'Pre-Order'
          : 'In Stock'
        : soldout
        ? 'Sold Out'
        : 'Made to Order';
      if (
        listItemClass == 'option rtw' ||
        (listItemClass == 'option rts' && rtw)
      ) {
        statusText = '';
      }

      DDL_html += `
        <li class="${listItemClass}" role="option" tabindex="0"
            data-variant-id="${variant.id}" data-color="${color}" onclick="setGlobalSkuOnClick('${variant.sku}')">
            <span class="variant-value">${size}</span>
            <span>${statusText}</span>
        </li>
      `;
      addedSizes.add(sizeKey);
    });
  } else {
    // Fallback: use inventory data directly (original behavior)
    inventoryData.forEach((item) => {
      const { variant_id, available, size, location } = item;
      if (['XL', 'SS', 'MM'].includes(size) || !location?.includes('318')) {
        return;
      }

      if (selectedColor) return; // Can't filter by color without product data

      let listItemClass = available
        ? 'option rts'
        : soldout && rtw
        ? 'option rtw'
        : 'option mto';
      let statusText = available
        ? is_pre_order
          ? 'Pre-Order'
          : 'In Stock'
        : soldout
        ? 'Sold Out'
        : 'Made to Order';

      let sizeKey = `${size}-Unknown`;

      if (!addedSizes.has(sizeKey)) {
        DDL_html += `
          <li class="${listItemClass}" role="option" tabindex="0"
              data-variant-id="${variant_id}" data-color="Unknown">
              <span class="variant-value">${size}</span>
              <span>${statusText}</span>
          </li>
        `;
        addedSizes.add(sizeKey);
      }
    });
  }

  custom_ddl.html(DDL_html);
  // ARIA 1.2: the ul only becomes a listbox once it owns role=option items
  custom_ddl.attr('role', 'listbox');
  $('.custom-dropdown span.loading-data').removeClass('loading');
}

function fetchProductAndInventoryData(selectedColor = null) {
  const product_id = $('.custom-dropdown .ddlist-options ul').data(
    'product-id'
  );
  if (!product_id) {
    console.error('Error: Product ID not found!');
    return;
  }

  const productHandle = window.location.pathname.split('/').pop();
  const productUrl = `/products/${productHandle}.json`;
  const inventoryUrl = `https://api.ecom.amsale.com/api/inventory/${product_id}`;

  Promise.all([
    fetch(productUrl)
      .then((res) => res.json())
      .catch((err) => console.error('❌ Error fetching product data:', err)),
    fetch(inventoryUrl)
      .then((res) => res.json())
      .catch((err) => console.error('❌ Error fetching inventory data:', err)),
  ])
    .then(([productData, inventoryData]) => {
      if (!productData?.product?.variants) {
        console.error('Invalid productData format!', productData);
        return;
      }

      const inventoryArray = inventoryData.inventory;
      if (!Array.isArray(inventoryArray)) {
        console.error(
          'Extracted inventoryArray is not an array!',
          inventoryArray
        );
        return;
      }

      const variantLookup = new Set(
        productData.product.variants.map((variant) => variant.id)
      );

      if (selectedColor) {
        const matchingVariant = productData.product.variants.find(
          (v) => v.option1.toLowerCase() === selectedColor.toLowerCase()
        );

        if (!matchingVariant) {
          console.warn('⚠ No matching variant found for color:', selectedColor);
          return;
        }

        $('#hidden-variant-id').val(matchingVariant.id);

        const filteredInventory = inventoryArray.filter((item) =>
          variantLookup.has(item.variant_id)
        );

        const sizeDropdown = $('.product-select--size select');
        const customDropdownList = $('.custom-dropdown .ddlist-options ul');
        customDropdownList.empty();
        // ARIA 1.2: the ul only becomes a listbox once it owns role=option items
        customDropdownList.attr('role', 'listbox');

        const addedSizes = new Set();

        if (filteredInventory.length > 0) {
          $('.current-selected-value').text('Select Size');
          filteredInventory.forEach(({ size, variant_id }) => {
            // Use Shopify variant size (option2) over API size when available
            const matchingVar = productData.product.variants.find(v => v.id == variant_id);
            const displaySize = matchingVar && matchingVar.option2 ? matchingVar.option2 : size;
            if (!addedSizes.has(displaySize)) {
              addedSizes.add(displaySize);
              sizeDropdown.append(`<option value="${displaySize}">${displaySize}</option>`);
              customDropdownList.append(
                `<li role="option" tabindex="0" data-variant-id="${variant_id}" data-color="${selectedColor}">${displaySize}</li>`
              );
            }
          });

          sizeDropdown.prop('disabled', false);
          $('.custom-dropdown .selected span').prop('disabled', false);
        } else {
          sizeDropdown.append('<option value="">No sizes available</option>');
          $('.custom-dropdown .selected span').styles.color = 'blue';
        }

        generateDropdownHTML(filteredInventory, productData, selectedColor);
        updateProductImages(matchingVariant.id, productData);
      } else {
        generateDropdownHTML(inventoryArray, productData);
      }
    })
    .catch((error) => console.error('Error fetching data:', error));
}

function updateProductImages(variantId, productData) {
  if (!variantId || !productData) {
    console.error('Missing variantId or productData');
    return;
  }

  const matchingVariant = productData.product.variants.find(
    (v) => String(v.id) === String(variantId)
  );
  if (!matchingVariant) {
    console.warn('No matching variant found in productData');
    return;
  }

  const selectedColor = matchingVariant.option1;

  // DESKTOP VERSION (> 992px)
  if ($(window).width() > 992) {
    let firstVisibleSlide = null;
    let visibleCount = 0;

    // Check if product has only 1 color from API data
    var colorOption = (productData.product.options || []).find(function(o) { return o.name === 'Color'; });
    var isSingleColorProduct = colorOption && colorOption.values.length <= 1;
    $('.image-main .slide').each(function () {
      const slideColor = $(this).attr('data-color');
      if (slideColor === selectedColor) {
        $(this).show();
        visibleCount++;
        if (!firstVisibleSlide) {
          firstVisibleSlide = $(this);
        }
      } else if (!slideColor && isSingleColorProduct) {
        // Single-color product: keep product.images visible
        $(this).show();
        visibleCount++;
        if (!firstVisibleSlide) {
          firstVisibleSlide = $(this);
        }
      } else {
        $(this).hide();
      }
    });

    if (firstVisibleSlide && visibleCount > 0) {
      setTimeout(function () {
        if (typeof initNativeScrollBar === 'function') {
          initNativeScrollBar();
        }
      }, 1000);
    } else {
      console.warn('Aucune image trouvée pour la couleur:', selectedColor);
      // Fallback: show all slides when no matching slides found
      $('.image-main .slide').show();
      // remove any existing desktop scrollbar if there are no matching slides
      try {
        const $imgMain = $('.image-main');
        $imgMain.find('.desktop-scrollbar').remove();
        $imgMain.css({ overflow: '', height: '' });
        // Re-init scrollbar with all visible slides
        setTimeout(function () {
          if (typeof initNativeScrollBar === 'function') {
            initNativeScrollBar();
          }
        }, 100);
      } catch (e) {
        // ignore
      }
    }
  }
  // MOBILE VERSION (≤ 992px)
  // Slide swapping is handled by showColorSlidesMobile from the swatch click handler.
  // Only re-init slick here if it's not already initialized (e.g. called from non-swatch context).
  else {
    const $imgMain = $('.image-main');
    if (!$imgMain.hasClass('slick-initialized')) {
      showColorSlidesMobile(selectedColor);
    }
  }
}

function setHiddenFieldValues() {
  const current_sku = $('input[type=hidden]#hidden-product-sku').val();
  const eta_date_element = $(
    '.estimated-delivery-date p#delivery_service_desc'
  );
  const hidden_eta_input = $('#hidden-product-estimated-date');
  const session_exists = sessionStorage.getItem('selected_options');
  const is_holiday = $('.estimated-delivery-date.is-holiday-date').length > 0;
  const metafieldDate = eta_date_element.data('metafield-date');
  const is_pre_order = $('input[type=hidden]#hidden-is-preorder').val();

  if (session_exists && current_sku == JSON.parse(session_exists).sku) {
    current_dress_size = JSON.parse(session_exists).dress_size;

    const custom_options = $('.custom-dropdown .ddlist-options ul li');
    custom_options.each(function (index) {
      if ($(this).find('span.variant-value').text() === current_dress_size) {
        if (is_pre_order && $(this).hasClass('rts')) {
          $('input[type=hidden]#product-properties-saletype').val('Pre-Order');
          if (metafieldDate) {
            hidden_eta_input.val(metafieldDate);
          }
        } else if ($(this).hasClass('mto')) {
          if (metafieldDate) {
            hidden_eta_input.val(metafieldDate);
          } else if (!is_holiday) {
            hidden_eta_input.val(eta_date_element.data().mtoDate);
          } else {
            hidden_eta_input.val(eta_date_element.data().holidayDate);
          }
          $('input[type=hidden]#product-properties-saletype').val(
            'Made to Order'
          );
        } else {
          $('input[type=hidden]#product-properties-saletype').val('In Stock');
          if (metafieldDate) {
            hidden_eta_input.val(metafieldDate);
          } else {
            hidden_eta_input.val(eta_date_element.data().instockDate);
          }
        }
      }
    });
  }
}

document.querySelectorAll('.detailBox .content a').forEach((link) => {
  const text = link.textContent.trim().toLowerCase();

  let is_boldmetrics =
    $('input[type=hidden]#hidden-product-boldmetrics-enabled').val() === 'true';

  if (text.includes('size guide')) {
    link.classList.add('size-chart-link-popup');
    link.href = '#size-guide';
    link.addEventListener('click', (e) => {
      e.preventDefault();
      $.magnificPopup.open({
        items: { src: '#size-guide', type: 'inline' },
        midClick: true,
      });
    });
  }

  if (text.includes('find my size') || text.includes('fit check tool')) {
    link.classList.add('fit-link-modal');
    link.href = '#find-my-size';

    link.addEventListener('click', (e) => {
      e.preventDefault();
      $('.boldmetrics-ssc-button, #ssc-boldmetrics-activator').click();
      return false;
    });
  }
  if (text.includes('measure')) {
    link.href =
      'https://amsale.com/blogs/amsale/how-to-measure-your-dress-size';
    link.target = '_blank';
  }
});
